
import { Mixins, Component } from 'vue-property-decorator';
import { IBTNCONF } from '@/types/base.d';
import api from '@/api/course';
import tButton from '@/components/Button/tButton.vue';
import BsMixin from '@/views/Home/mixins/bsMixin';
import tableMixin from './tableMixin';
import bModal from './components/bModal.vue';

@Component({
  components: {
    tButton,
    bModal,
  },
})
export default class AssetWrapper extends Mixins(BsMixin, tableMixin) {
  private arrs: Array<any> = [];

  private actionBtns: Array<IBTNCONF> = [{
    title: '新增',
    name: '/course/chapter/knowledge:add',
    icon: 'plus',
    callback: this.handleAddResource,
    log: {
      name: '知识点 - 新增',
      component: '/course/chapter/knowledge:add',
    },
  }];

  private visible: any = {
    upload: false,
    contract: false,
    rescource: false,
    cropper: false,
  };

  private row: any = {};

  private title: string = '添加视频';

  public $refs!: {
    rescource: Element,
  }

  mounted() {
    this.initBS(this.$refs.rescource);
  }

  handleAddResource() {
    this.row.stepPid = this.chapterId;
    this.title = '添加知识点';
    this.visible.rescource = true;
  }

  handleEdit(row: any) {
    this.visible.rescource = true;
    this.title = '修改知识点';
    this.row = row;
  }

  refrsh() {
    this.getData(this.chapterId);
  }

  handleCellClick(row:any, column: any, event: any) {
    if (column.label === '缩略图标') {
      this.visible.cropper = true;
      this.row = row;
    }
  }
}
